// extracted by mini-css-extract-plugin
export default {"SchoolOption":"ChangeSchool_SchoolOption__gHdgg"};